/**
 * Базовый URL REST API (логин, /api/auth/me, кошелёк).
 * В dev по умолчанию тот же порт, что и Colyseus (`REACT_APP_COLYSEUS_PORT` или 3334).
 * В production: если задан `REACT_APP_API_BASE_URL` (например Fly `https://…fly.dev`), используется он; иначе '' (same-origin).
 */
function colyseusPort() {
  const fromEnv = process.env.REACT_APP_COLYSEUS_PORT;
  if (typeof fromEnv === 'string' && /^\d+$/.test(fromEnv.trim())) return fromEnv.trim();
  return '3334';
}

/** Strip trailing slashes for stable fetch(`${base}/api/...`). */
function normalizeApiBase(raw) {
  if (typeof raw !== 'string') return '';
  return raw.trim().replace(/\/+$/, '');
}

export function getApiBaseUrl() {
  const fromEnv = normalizeApiBase(process.env.REACT_APP_API_BASE_URL);
  if (process.env.NODE_ENV === 'production') {
    if (fromEnv) return fromEnv;
    return '';
  }
  if (fromEnv) return fromEnv;
  const port = colyseusPort();
  if (typeof window === 'undefined') return `http://localhost:${port}`;
  const isLocalhost = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  if (isLocalhost) return `http://localhost:${port}`;
  return `http://${window.location.hostname}:${port}`;
}
